<!--  -->
<template>
  <div class="diffTime">直播倒计时: {{ showTime }}</div>
</template>

<script>
import { replaceHyphens, timerYhqCount } from '@/utils/tools';
export default {
  components: {},
  data() {
    return {
      showTime: '',
    };
  },
  props: {
    receiveTimeEnd: {
      type: String,
      default: '',
    },
  },
  computed: {},
  watch: {},

  created() {
    this.countTime();
  },
  mounted() {},
  methods: {
    diffCount(dateTime, type) {
      const times = {};
      const d = parseInt(dateTime / 1000 / 60 / 60 / 24); // 算出天数
      const h = parseInt((dateTime / 1000 / 60 / 60) % 24); // 算出小时数
      const m = parseInt((dateTime / 1000 / 60) % 60); // 算出分钟数
      const s = parseInt((dateTime / 1000) % 60); // 算出秒数
      times.day = `${d > 0 ? `${d}天 ` : ''}`;
      if (type) {
        times.day = `${d > 0 && d >= 99 ? `${99} 天` : d > 0 && d < 99 ? `${d} 天` : ''}`;
      }
      times.hour = h > 9 ? h : `0${h}`;
      times.min = m > 9 ? m : `0${m}`;
      times.sen = s > 9 ? s : `0${s}`;
      return `${times.day}${times.hour}小时 ${times.min}分${times.sen}秒`;
    },

    countTime() {
      // 当前时间戳
      const now = new Date().getTime();
      // 结束时间戳
      const end = new Date(replaceHyphens(this.receiveTimeEnd)).getTime();
      // 做判断当倒计时结束时都为0
      if (now >= end) {
        this.showTime = '00:00:00';
        this.$emit('timerCountEnd');
        return;
      }
      // 用结束时间减去当前时间获得倒计时时间戳
      let temp = end - now + 1000;
      this.timers = setInterval(() => {
        temp -= 1000;
        if (temp > 0) {
          this.showTime = this.diffCount(temp);
        } else {
          this.showTime = '00:00:00';
          clearInterval(this.timers);
          this.$emit('timerCountEnd');
        }
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
.diffTime {
  font-weight: 500;
  font-size: 24px;
  color: #ffffff;
  text-align: center;
}
</style>
